export default "__VITE_ASSET__C7CZmmh9__"